
//Defines all the Field Group Types available in the app.
//IMPORTANT: Must be mapped to each specific field group type keyword to work properly.
export enum BlogTaxonomyPageKeyword {
  Blog = 'blog-categories',
  IoSonoVege = 'iosonovege-categories',
  PressReleases = 'press-categories',
}
